import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import { BuildingFillAdd, PencilSquare, Trash } from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import { getData, deleteData } from "../../Utils/Http/api";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const columns = [
  { Header: "Tipo Mensaje", accessor: "tipoMensaje", align: "left" },
  { Header: "Mensaje", accessor: "texto", align: "left" },
  { Header: "Acciones", accessor: "action", align: "center" },
];

function MensajeList() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, msg: "", severity: "success" });
  const [deleting, setDeleting] = useState(false);

  const fetchData = async () => {
    try {
      const response = await getData("/MensajeListar");
      setItems(Array.isArray(response?.value) ? response.value : []);
    } catch (ex) {
      console.error("Error cargando Mensajes:", ex);
      setSnackbar({ open: true, msg: "No se pudieron cargar los mensajes", severity: "error" });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const rows = items.map((item) => ({
    tipoMensaje: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {item.tipoMensaje}
      </MDTypography>
    ),
    texto: (
      <MDTypography variant="caption" color="text" sx={{ whiteSpace: "pre-wrap" }}>
        {item.texto}
      </MDTypography>
    ),
    action: (
      <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
        <Link to={`../MensajeEdit/${item.idMensaje}`}>
          <MDButton variant="text" color="dark">
            <PencilSquare color="blue" />
          </MDButton>
        </Link>
        <MDButton variant="text" color="dark" onClick={() => setDeleteId(item.idMensaje)}>
          <Trash color="red" />
        </MDButton>
      </MDBox>
    ),
  }));

  const handleConfirmDelete = async () => {
    try {
      setDeleting(true);
      const res = await deleteData(`/MensajeDelete/${deleteId}`);
      if (res?.isSuccess) {
        setSnackbar({ open: true, msg: "Mensaje eliminado", severity: "success" });
        await fetchData();
      } else {
        setSnackbar({ open: true, msg: res?.error || "No se pudo eliminar", severity: "error" });
      }
    } catch (ex) {
      setSnackbar({ open: true, msg: ex?.detail || ex?.message || "No se pudo eliminar", severity: "error" });
    }
    setDeleteId(null);
    setDeleting(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="secondary"
                borderRadius="lg"
                coloredShadow="light"
              >
                <MDTypography variant="h6" color="white">
                  Mensajes
                </MDTypography>
              </MDBox>

              <MDBox pt={3} py={3} px={2}>
                <MDButton
                  onClick={() => navigate("/MensajeAdd")}
                  variant="gradient"
                  color="success"
                  endIcon={<BuildingFillAdd />}
                >
                  Agregar
                </MDButton>

                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries
                  canSearch={false}
                  noEndBorder
                  pagination={{ color: "info", variant: "gradient" }}
                />

                <Dialog open={deleteId !== null} onClose={() => setDeleteId(null)}>
                  <DialogTitle>Confirmar eliminación</DialogTitle>
                  <DialogContent>¿Seguro que deseas eliminar este Mensaje? 🗑️</DialogContent>
                  <DialogActions>
                    <MDButton variant="text" color="dark" onClick={() => setDeleteId(null)}>
                      Cancelar
                    </MDButton>
                    <MDButton variant="gradient" color="error" onClick={handleConfirmDelete} disabled={deleting}>
                      Eliminar
                    </MDButton>
                  </DialogActions>
                </Dialog>

                <Snackbar
                  open={snackbar.open}
                  autoHideDuration={4000}
                  onClose={() => setSnackbar({ ...snackbar, open: false })}
                >
                  <MuiAlert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    elevation={6}
                    variant="filled"
                  >
                    {snackbar.msg}
                  </MuiAlert>
                </Snackbar>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default MensajeList;
